import React from 'react';
import AbstractWidget from './AbstractWidget';
import Slider from 'react-slick';
import translate from 'react-i18next/dist/commonjs/translate';
import { getCMSWidgetClassByObject } from '../cmsLib';

class CarrouselWidget extends AbstractWidget {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
        };
    }

    getLabels(labels, type) {
        if (labels) {
            return labels[type].value.replace(/(\r\n|\n|\r)/gm, '');
        }
        return null;
    }

    renderWidgets(widget) {
        let Clazz = getCMSWidgetClassByObject(widget);
        return <Clazz key={'wig-' + widget.orden} widget={widget} className={'cmsCarrouselItem widgetPos_' + widget.orden} parameters={{ displayImage: true }} />;
    }

    render() {
        var settings = {
            dots: true,
            arrows: false,
            swipe: false,
            autoplay: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1
        };
        const { widget, parameters, className } = this.props;
        if (parameters) {
            settings = { ...settings, ...parameters };
        }
        return (widget && widget.widgets?
            <div className={'cmsCarrouselWidget ' + (widget.hidden && 'hidden') + ' ' + className} >
                <Slider {...settings}>
                    {widget && widget.widgets && widget.widgets.map(widget => this.renderWidgets(widget))}
                </Slider>
            </div>
            : ''
        );
    }
}

export default translate('translations')(CarrouselWidget);


// WEBPACK FOOTER //
// ./src/cms/widgets/CarrouselWidget.js